/**
 * Spine (kernel-native: the kernel is the system of record; no coreBOS module yet).
 * Roles/job titles (mansioni). Shared by GDPR (authorised persons), 81/08 (worker groups) and NIS2 (responsibilities).
 * Hand-written (ADR-029 §4); links to other spines are graph edges, see src/spines.ts.
 */
export const roleDescriptor = {
    slug: 'cmp_role',
    kind: 'document',
    label: { singular: 'Ruolo', plural: 'Ruoli' },
    table: 'compliance_role',
    idStrategy: 'sha256',
    fields: [
        { name: 'name', type: 'text', label: 'Nome', required: true },
        { name: 'description', type: 'text', label: 'Descrizione' },
        { name: 'is_safety_role', type: 'boolean', label: 'Ruolo sicurezza (81/08)' },
    ],
    relations: [
        { name: 'org_unit', kind: 'belongsTo', target: 'cmp_org_unit' },
    ],
    behaviors: { audit: true, softDelete: true, tenantScoped: true },
    ui: { mode: 'generated', icon: 'IdcardOutlined', navGroup: 'Organizzazione' },
};
